import { Button } from "@alpacahq/ui/old";

import { SealCheckIcon } from "~/v2/components/common";

interface FpslAgreementBoxProps {
  isAccepted: boolean;
  onOpen: () => void;
}

export const FpslAgreementBox = ({
  isAccepted,
  onOpen,
}: FpslAgreementBoxProps) => (
  <article className="flex items-center justify-between gap-4 rounded border border-gray-300 bg-white p-2">
    <div className="flex items-center justify-start gap-2">
      {isAccepted && <SealCheckIcon />}
      <h3 className="m-0 p-0 font-semibold text-gray-800 text-sm">
        Master Securities Lending Agreement
      </h3>
    </div>
    {isAccepted ? (
      <Button variant="v2/ghost" size="v2/small" onClick={onOpen}>
        View Terms
      </Button>
    ) : (
      <Button variant="v2/filled" size="v2/small" onClick={onOpen}>
        Enroll
      </Button>
    )}
  </article>
);
